<!-- eslint-disable no-mixed-operators -->
/* eslint-disable max-len */
<template>
  <div
    :class="styling"
    style="cursor: pointer"
    v-on:click="showClassCultureLegend()"
  >
    <i class="info circle icon"></i>Class Culture {{ ratio }} {{ health }} class
    culture
    <div style="padding-top: 8px">
      <span>Total amount of students:</span>
      <span>{{ testResult.amountOfStudents }}</span>
      <br />
      <span>Class total likes:</span>
      <span>{{ testResult.totalLikes }}</span>
      <br />
      <span>Class total rejects:</span>
      <span>{{ testResult.totalDislikes }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TestClassCulture',
  components: {},
  computed: {
    ratio() {
      return ` is ${this.testResult.averageLikes}:${this.testResult.averageRejects}, which indicates`;
    },
    health() {
      if (this.testResult.classCulture > 7) {
        return 'a healthy';
      } else if (
        this.testResult.classCulture > 1 &&
        this.testResult.classCulture < 7
      ) {
        return '"not a healthy"';
      }
      return 'an unhealthy';
    },
    styling() {
      if (this.testResult.classCulture > 7) {
        return 'row ui positive message';
      } else if (
        this.testResult.classCulture > 1 &&
        this.testResult.classCulture < 7
      ) {
        return 'row ui warning message';
      }
      return 'row ui negative message';
    },
  },
  props: ['testResult'],
  data() {
    return {};
  },
  methods: {
    showClassCultureLegend() {
      this.$store.dispatch('showClassCultureLegend');
    },
    hideClassCultureLegend() {
      this.$store.dispatch('hideClassCultureLegend');
    },
  },
  created() {},
};
</script>



// WEBPACK FOOTER //
// src/components/tests/TestClassCulture.vue